import React, { Component } from "react";
import { PageHeader, Row, Col, Table, Tag, Button, Checkbox, DatePicker, Empty } from "antd";
import CashHandoverService from "../../services/cashhandoverservice";
import moment from "moment";

/**
 * Ops review of agent cash handovers (all agents). The verdict (StatusLabel /
 * NeedsReview / ReviewReasons) is computed server-side; this screen presents it.
 * Flagged rows (sent back, or pending past expiry) sort naturally to the top via
 * the "only flagged" default and the amber row highlight.
 */
export default class CashHandover extends Component {
  constructor(props) {
    super(props);
    this.service = new CashHandoverService();
    this.state = {
      fromDate: moment().subtract(7, "days"),
      toDate: moment(),
      onlyFlagged: false,
      rows: [],
      loading: false,
    };
  }

  componentDidMount() {
    this.load();
  }

  load = async () => {
    this.setState({ loading: true });
    let res;
    try {
      res = await this.service.getForReview(
        this.state.fromDate ? this.state.fromDate.format("YYYY-MM-DD") : null,
        this.state.toDate ? this.state.toDate.format("YYYY-MM-DD") : null,
        0,
        this.state.onlyFlagged ? 1 : 0
      );
    } catch (e) {
      res = [];
    }
    const rows = Array.isArray(res) ? res : Array.isArray(res && res.data) ? res.data : [];
    this.setState({ rows, loading: false });
  };

  statusTag = (r) => {
    const s = Number(r.status);
    const color = s === 2 ? "green" : s === 1 ? "gold" : s === 3 ? "red" : "default";
    return <Tag color={color}>{r.statusLabel}</Tag>;
  };

  render() {
    const money = (v) =>
      "₹" + Number(v || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

    const columns = [
      {
        title: "Agent",
        key: "agent",
        render: (r) => (
          <div>
            <div style={{ fontWeight: 600 }}>{r.agentName || "-"}</div>
            <div style={{ color: "#888", fontSize: 12 }}>{r.agentMobile}</div>
          </div>
        ),
      },
      { title: "Handed to", dataIndex: "receiverName", key: "recv", render: (v) => v || "-" },
      { title: "Store", dataIndex: "storeName", key: "store", render: (v) => v || "-" },
      { title: "Amount", key: "amt", align: "right", render: (r) => money(r.amount) },
      { title: "Status", key: "status", render: (r) => this.statusTag(r) },
      { title: "When", dataIndex: "createdOn", key: "created" },
      {
        title: "Needs a look",
        key: "review",
        render: (r) =>
          Number(r.needsReview) === 1 ? (
            <span style={{ color: "#cf1322" }}>{r.reviewReasons || "Review"}</span>
          ) : (
            <span style={{ color: "#aaa" }}>{r.reviewReasons || "—"}</span>
          ),
      },
    ];

    const { rows } = this.state;
    const flagged = rows.filter((r) => Number(r.needsReview) === 1).length;

    return (
      <div style={{ padding: 16 }}>
        <PageHeader
          title="Cash handover"
          subTitle="Every agent's cash hand-in, with what still needs a look"
          style={{ paddingLeft: 0 }}
        />
        <Row gutter={16} align="bottom" style={{ marginBottom: 12 }}>
          <Col>
            <div>From</div>
            <DatePicker
              value={this.state.fromDate}
              format="DD-MM-YYYY"
              onChange={(d) => this.setState({ fromDate: d })}
            />
          </Col>
          <Col>
            <div>To</div>
            <DatePicker
              value={this.state.toDate}
              format="DD-MM-YYYY"
              onChange={(d) => this.setState({ toDate: d })}
            />
          </Col>
          <Col>
            <Checkbox
              checked={this.state.onlyFlagged}
              onChange={(e) => this.setState({ onlyFlagged: e.target.checked })}
            >
              Only handovers that need a look
            </Checkbox>
          </Col>
          <Col flex="auto" style={{ textAlign: "right" }}>
            <Button type="primary" loading={this.state.loading} onClick={this.load}>
              Show
            </Button>
          </Col>
        </Row>

        <div style={{ margin: "6px 0 10px", color: "#666" }}>
          {rows.length} handover{rows.length === 1 ? "" : "s"} &middot; {flagged} need a look
        </div>

        <Table
          rowKey="handoverID"
          columns={columns}
          dataSource={rows}
          loading={this.state.loading}
          pagination={{ pageSize: 25, hideOnSinglePage: true }}
          rowClassName={(r) => (Number(r.needsReview) === 1 ? "lk-flagged-row" : "")}
          locale={{ emptyText: <Empty description="No handovers in this range" /> }}
        />
        <style>{`.lk-flagged-row td{background:#fffbe6 !important;}`}</style>
      </div>
    );
  }
}
